import React, { useMemo } from 'react';
import { createAuthenticatedCaptureClient } from '../../audio/authenticatedCaptureClient';
import { VoiceCaptureTarget } from '../../audio/captureClient';
import { useApp } from '../../context/AppContext';
import GuidedCapture from './GuidedCapture';

interface Props {
  onComplete: () => void;
  onCancel: () => void;
  existingVoiceId?: string;
  existingVoiceName?: string;
}

const VoiceCreationFlow: React.FC<Props> = ({
  onComplete,
  onCancel,
  existingVoiceId,
  existingVoiceName,
}) => {
  const { state, trainVoice, fetchVoices } = useApp();
  const draftScopeKey = state.user?.id || 'session';
  const client = useMemo(() => createAuthenticatedCaptureClient({
    draftScopeKey,
    startVoiceBuild: trainVoice,
    refreshVoices: fetchVoices,
  }), [draftScopeKey, fetchVoices, trainVoice]);
  const target = useMemo<VoiceCaptureTarget>(() => ({
    kind: 'voice',
    voiceId: existingVoiceId,
  }), [existingVoiceId]);
  const speakerDisplayLabel = state.user?.full_name
    || state.user?.name
    || 'your family';

  return (
    <GuidedCapture
      client={client}
      target={target}
      voiceLabel={existingVoiceName || ''}
      speakerDisplayLabel={speakerDisplayLabel}
      onComplete={onComplete}
      onCancel={onCancel}
    />
  );
};

export default VoiceCreationFlow;
